import { match } from "@formatjs/intl-localematcher";
import { computed, signal } from "@preact/signals-react";

import {
	DEFAULT_DISPLAY_MODE,
	DEFAULT_LOCALE,
	DEFAULT_MAX_NUMBER_OF_TRIPS,
	DEFAULT_MAX_TIME_WINDOW,
	DEFAULT_MIN_TIME_WINDOW,
	DEFAULT_TIME_FORMAT,
	SUPPORTED_LOCALES,
} from "../../constants";

import "@formatjs/intl-locale/polyfill";
import type {
	DisplayMode,
	MaxNumberOfTrips,
	MaxTimeWindow,
	MinTimeWindow,
	SupportedLocale,
	TimeFormat,
} from "../../types/types";

const URLSearchParams = new URL(window.location.href).searchParams;

const DEFAULT_PRIMARY_LOCALE: SupportedLocale = match(
	Array.from(navigator.languages),
	SUPPORTED_LOCALES,
	DEFAULT_LOCALE,
) as SupportedLocale;
export const primaryLocale = signal<SupportedLocale>(
	(URLSearchParams.get("primary-locale") || DEFAULT_PRIMARY_LOCALE) as SupportedLocale,
);
export const secondaryLocale = signal<SupportedLocale | null>(
	URLSearchParams.get("secondary-locale") as SupportedLocale,
);
export const ternaryLocale = signal<SupportedLocale | null>(URLSearchParams.get("ternary-locale") as SupportedLocale);
export const timeZone = signal<string | null>(URLSearchParams.get("tz") as string | null);
export const displayMode = signal<DisplayMode>(
	(URLSearchParams.get("display-mode") || DEFAULT_DISPLAY_MODE) as DisplayMode,
);
export const timeFormat = signal<TimeFormat>(
	(URLSearchParams.get("time-format") ? Number(URLSearchParams.get("time-format")) : DEFAULT_TIME_FORMAT) as TimeFormat,
);
export const minTimeWindow = signal<MinTimeWindow>(
	(URLSearchParams.get("min-time-window")
		? Number(URLSearchParams.get("min-time-window"))
		: DEFAULT_MIN_TIME_WINDOW) as MinTimeWindow,
);
export const maxTimeWindow = signal<MaxTimeWindow>(
	(URLSearchParams.get("max-time-window")
		? Number(URLSearchParams.get("max-time-window"))
		: DEFAULT_MAX_TIME_WINDOW) as MaxTimeWindow,
);
export const maxNumberOfTrips = signal<MaxNumberOfTrips>(
	(URLSearchParams.get("max-number-of-trips")
		? Number(URLSearchParams.get("max-number-of-trips"))
		: DEFAULT_MAX_NUMBER_OF_TRIPS) as MaxNumberOfTrips,
);
export const stationCode = signal<string | null>(null);

export const searchParamsSettings = computed(() => ({
	...(primaryLocale.value !== DEFAULT_PRIMARY_LOCALE && {
		"primary-locale": primaryLocale.value,
	}),
	...(secondaryLocale.value && { "secondary-locale": secondaryLocale.value }),
	...(ternaryLocale.value && { "ternary-locale": ternaryLocale.value }),
	...(timeZone.value && { tz: timeZone.value }),
	...(displayMode.value !== DEFAULT_DISPLAY_MODE && {
		"display-mode": displayMode.value,
	}),
	...(minTimeWindow.value !== DEFAULT_MIN_TIME_WINDOW && {
		"min-time-window": minTimeWindow.value,
	}),
	...(maxTimeWindow.value !== DEFAULT_MAX_TIME_WINDOW && {
		"max-time-window": maxTimeWindow.value,
	}),
	...(maxNumberOfTrips.value !== DEFAULT_MAX_NUMBER_OF_TRIPS && {
		"max-number-of-trips": maxNumberOfTrips.value,
	}),
	...(timeFormat.value !== DEFAULT_TIME_FORMAT && {
		"time-format": timeFormat.value,
	}),
}));
